import React from 'react';
import { Home, Search, PlusCircle, User, Tag, Users } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { cn } from '../lib/utils';
import { useFavorites } from '../context/FavoritesContext';
import useMunicipioBasePath from '../hooks/useMunicipioBasePath';

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { count: favoritesCount } = useFavorites();
  const { basePath } = useMunicipioBasePath();

  const navItems = [
    { icon: Home, label: 'Home', path: basePath || '/', testid: 'nav-home' },
    { icon: Search, label: 'Explorar', path: `${basePath}/explorar`, testid: 'nav-explorar' },
    { icon: Tag, label: 'Promoções', path: `${basePath}/campanhas`, testid: 'nav-promocoes' },
    { icon: Users, label: 'Social', path: `${basePath}/social`, testid: 'nav-social' },
    { icon: PlusCircle, label: 'Cadastrar', path: `${basePath}/cadastrar`, testid: 'nav-cadastrar' },
    { icon: User, label: 'Perfil', path: `${basePath}/perfil`, testid: 'nav-perfil' },
  ];

  return (
    <nav 
      className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-[var(--border)] shadow-lg pb-[env(safe-area-inset-bottom)]"
      data-testid="bottom-nav"
      role="navigation"
      aria-label="Navegação principal"
    >
      <div className="max-w-7xl mx-auto px-0.5 sm:px-4">
        <div className="flex items-center justify-around">
          {navItems.map(({ icon: Icon, label, path, testid, badge }) => {
            const isActive = location.pathname === path;
            return (
              <button
                key={path}
                onClick={() => {
                  navigate(path);
                  // Scroll instantâneo + após render (cobre o caso de useTenantGeoRedirect
                  // que pode causar um segundo navigate antes do scroll do useEffect)
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                  requestAnimationFrame(() => window.scrollTo({ top: 0, behavior: 'smooth' }));
                  setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 250);
                }}
                className={cn(
                  "flex flex-col items-center gap-1 py-3 px-0.5 sm:px-4 transition-colors flex-1 min-w-0 relative",
                  isActive ? "text-[var(--primary)]" : "text-[var(--text-secondary)]"
                )}
                data-testid={testid}
                aria-label={label}
                aria-current={isActive ? 'page' : undefined}
              >
                <div className="relative">
                  <Icon className={cn("w-5 h-5", label === 'Favoritos' && isActive && 'fill-current')} />
                  {badge > 0 && (
                    <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 text-white text-[10px] rounded-full flex items-center justify-center font-bold">
                      {badge > 9 ? '9+' : badge}
                    </span>
                  )}
                </div>
                <span className="text-[10px] sm:text-xs font-medium truncate max-w-full">{label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
